<template>
  <div :class="bem()">
    <VisionHeading
      size="h4"
      tag="h3"
      colour-style="grey"
      font-weight="light"
      :class="bem('title')"
    >
      Let's change that...
    </VisionHeading>
    <div :class="bem('items')">
      <template v-if="status === 'success' && data">
        <VisionCard
          v-for="item in data.cart.emptyItems"
          :key="item.title"
          :link="resolveLocalePath(slugToPagePath(item.link.internalLink.slug))"
          aspect-ratio="4/5"
          :scrim="64"
          icon-button="outline"
          :title="item.title"
          :description="item.subtitle"
          tag="h2"
        >
          <template #image>
            <DatoCmsImage
              :data="item.image.responsiveImage"
              layout="fill"
              object-fit="cover"
              :object-position="`${item.image.focalPoint.x * 100}% ${
                item.image.focalPoint.y * 100
              }%`"
              sizes="(max-width: 600px) 200px, 250px"
            />
          </template>
        </VisionCard>
      </template>
      <template v-else>
        <div
          v-for="i in 6"
          :key="i"
          :class="[bem('loading'), 'vision-shimmer']"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import query from '~/gql/cart.gql'
import { Image as DatoCmsImage } from 'vue-datocms'

const bem = useBEM('CartSidebarEmpty')
const shopifyStore = useShopifyStore()
const { resolveLocalePath, slugToPagePath } = useUrlBuilder()

const { data, execute, status } = useDatoQuery({
  query
})

watch(() => shopifyStore.open, (newValue) => {
  if (newValue && !data) {
    execute()
  }
})
</script>

<style lang="postcss">
.CartSidebarEmpty {
  @apply p-[var(--cart-inline-padding)] pt-0 overflow-auto
  max-h-[var(--cart-content-height)]
}

.CartSidebarEmpty__title {
  @apply mb-3;
}

.CartSidebarEmpty__items {
  @apply grid grid-cols-2 gap-3 md:gap-4;
}

.CartSidebarEmpty__loading {
  @apply w-full aspect-[4/5];
}
</style>